import { ListType } from '@epicuro-next/models/engagement';

export function isNormalList<
  T extends {
    type?: ListType | string | null;
    originalType?: ListType | string | null;
  },
>(list?: T | null): boolean {
  const typeNormal = ListType.Normal.toLowerCase();
  if (!list?.type) {
    return true;
  }
  return (
    list?.type?.toLowerCase() === typeNormal ||
    list?.originalType?.toLowerCase() === typeNormal
  );
}

export function isCommercialList<
  T extends {
    type?: ListType | string | null;
    originalType?: ListType | string | null;
  },
>(list?: T | null): boolean {
  const typeCommercial = ListType.Commercial.toLowerCase();
  return (
    list?.type?.toLowerCase() === typeCommercial ||
    list?.originalType?.toLowerCase() === typeCommercial
  );
}

export function isPowerList<
  T extends {
    type?: ListType | string | null;
    originalType?: ListType | string | null;
  },
>(list?: T) {
  const typePower = ListType.Power.toLowerCase();
  return typePower === list?.type?.toLowerCase();
}
